/**
 * Impersonation côté front — outil de test admin uniquement.
 *
 * Réutilise un simple flag localStorage. L'`apiClient` lit ce flag à chaque
 * requête et envoie le header `X-Impersonate-As`. Le backend rejette le header
 * si l'appelant n'est pas admin (cf. ClerkAuthGuard), donc même si quelqu'un
 * forge la valeur localStorage, ça ne lui donne aucun pouvoir supplémentaire.
 */
const STORAGE_KEY = 'doorly:impersonate:userId';
const NAME_KEY = 'doorly:impersonate:displayName';

export function getImpersonatedUserId(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(STORAGE_KEY);
}

export function getImpersonatedDisplayName(): string | null {
  if (typeof window === 'undefined') return null;
  return localStorage.getItem(NAME_KEY);
}

export function setImpersonation(userId: string, displayName: string): void {
  localStorage.setItem(STORAGE_KEY, userId);
  localStorage.setItem(NAME_KEY, displayName);
}

export function clearImpersonation(): void {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(NAME_KEY);
}

export function isImpersonating(): boolean {
  return getImpersonatedUserId() !== null;
}
